module.exports = __webpack_public_path__ + "static/media/arrow-left-calendar.4781da6d.svg";